import React, {memo} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {hasPermission} from "helpers/helper";
import {IconBullHorn} from "components/icons";
import {LockValue} from "components/LockValue";

const OpenRfpsSettings = memo(({settings, onUpdate}) => {
  const {t} = useTranslation();

  return (
    <div className="organization-settings__department-labels mb-12">
      <SubHeading
        title="SETTINGS_ORGANIZATION_PUBLIC_RFP_TITLE"
        icon={<IconBullHorn />}
        hasNew
      />
      <div className="mt-4">{t("SETTINGS_ORGANIZATION_PUBLIC_RFP_DESCRIPTION")}</div>
      <LockValue
        canPermissions={["ENABLE_SWITCH_OFF_CREATE_OPEN_RFT"]}
        needLabel
        addClassIcon="mt-4"
        needShowModalToSubscribe
      >
        <CustomRadioSwitch
          checked={settings?.allowPublicRft}
          mediumText
          label={t("SETTINGS_ORGANIZATION_PUBLIC_RFP_SWITCH_02_LABEL")}
          small
          addWrapperClass="mt-4"
          informationText="SETTINGS_ORGANIZATION_PUBLIC_RFP_SWITCH_02_TOOLTIP"
          isActive={(checked) =>
            hasPermission(["ENABLE_SWITCH_OFF_CREATE_OPEN_RFT"]) &&
            onUpdate({allowPublicRft: checked})
          }
        />
      </LockValue>

      <LockValue
        canPermissions={["ENABLE_SWITCH_OFF_CREATE_OPEN_RFT"]}
        needLabel
        addClassIcon="mt-4"
        needShowModalToSubscribe
      >
        <CustomRadioSwitch
          checked={settings?.publicRrfDefault}
          mediumText
          label={t("SETTINGS_ORGANIZATION_PUBLIC_RFP_SWITCH_03_LABEL")}
          small
          addWrapperClass="mt-4"
          informationText="SETTINGS_ORGANIZATION_PUBLIC_RFP_SWITCH_03_TOOLTIP"
          isActive={(checked) =>
            hasPermission(["ENABLE_SWITCH_OFF_CREATE_OPEN_RFT"]) &&
            onUpdate({publicRrfDefault: checked})
          }
          disabled={
            !settings?.allowPublicRft ||
            !hasPermission(["ENABLE_SWITCH_OFF_CREATE_OPEN_RFT"])
          }
        />
      </LockValue>
    </div>
  );
});

export default OpenRfpsSettings;
